/**
 * Copyright 2015, Yahoo! Inc.
 * Copyrights licensed under the New BSD License. See the accompanying LICENSE file for terms.
 */

// 'use strict';

/*
 * Bing MapImage Service
 * @class BingMapService
 */

Object.defineProperty(exports, '__esModule', {
    value: true,
});

const _createClass = (function() {
    function defineProperties(target, props) {
        for (let i = 0; i < props.length; i++) {
            const descriptor = props[i];
            descriptor.enumerable = descriptor.enumerable || false;
            descriptor.configurable = true;
            if ('value' in descriptor) descriptor.writable = true;
            Object.defineProperty(target, descriptor.key, descriptor);
        }
    }
    return function(Constructor, protoProps, staticProps) {
        if (protoProps) defineProperties(Constructor.prototype, protoProps);
        if (staticProps) defineProperties(Constructor, staticProps);
        return Constructor;
    };
})();

const _config = require('../../config/config.json');

const _url = require('url');

const _url2 = _interopRequireDefault(_url);

function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : { default: obj };
}

function _classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
        throw new TypeError('Cannot call a class as a function');
    }
}

const _ = {
    // Collection
    pick: require('lodash/pickBy'),
    identity: require('lodash/identity'),
};

const BingMapService = (function() {

    function BingMapService() {
        _classCallCheck(this, BingMapService);
    }

    _createClass(BingMapService, [
        {
            key: 'getMap',

            /**
         * Get the map location details for the address provided in the params
         *
         * @param {Object} params
         * @returns {{mapId: (*|string|string|string|string), data: {locationLink: *, locationText: string}}}
         */
            value: function getMap(params) {
                let locationText = void 0;
                let location = void 0;
                let pushpin = void 0;
                let url = void 0;

                // if (isFinite(params.longitude) && isFinite(params.latitude)) {
                //     pushpin = location = locationText = [params.latitude, params.longitude].join(',');
                //     if (isFinite(params.zoom)) {
                //         location = [location, params.zoom].join('/');
                //     }
                // } else {
                //     location = locationText = [params.line1, params.line2, params.line3].join(',');
                // }

                if (isFinite(params.longitude) && isFinite(params.latitude)) {
                    pushpin = location = locationText = [params.latitude, params.longitude].join(
                        ',',
                    );
                    if (isFinite(params.zoom)) {
                        location = [location, params.zoom].join('/');
                    }
                }
                if (params.line1 !== '') {
                    locationText = params.line1;
                    location = location || locationText;
                }

                url = _url2.default.format({
                    protocol: _config.bing.protocol,
                    hostname: _config.bing.host,
                    pathname: _config.bing.path + encodeURIComponent(location.substring(0, location.lastIndexOf('/'))) + location.substring(location.lastIndexOf('/')),
                    query: _.pick(
                        {
                            mapSize: [params.width, params.height].join(','),
                            key: params.providerKey,
                            pushpin,
                        },
                        _.identity,
                    ),
                });

                return {
                    mapId: params.mapId,
                    data: {
                        locationLink: url,
                        locationText,
                    },
                };
            },
        },
        {
            key: 'name',
            get: function get() {
                return _config.bing.name;
            },
        },
    ]);

    return BingMapService;
})();

exports.default = BingMapService;



// WEBPACK FOOTER //
// ./src/containers/PrivateArea/Meeting/components/react-cartographer/lib/lib/bingMap.js